import type { DrumId } from '../types';
import { getDrumsChannelGain } from '../utils/mixVolumes';
import {
  getAudioContext,
  loadTrimmedSample,
  playSampleNow,
} from './webAudioEngine';

const DRUM_URLS: Record<DrumId, string> = {
  kick: '/junior-assets/sounds/kick.wav',
  snare: '/junior-assets/sounds/snare.wav',
  hihat: '/junior-assets/sounds/hihat.wav',
  shaker: '/junior-assets/sounds/shaker.wav',
};

/** Umbral más alto: percusión corta, recorte agresivo de silencio. */
const DRUM_TRIM_THRESHOLD = 0.018;

let preloadPromise: Promise<void> | null = null;

function drumKey(drum: DrumId): string {
  return `drum:${drum}`;
}

export async function preloadDrumSamples(): Promise<void> {
  if (!preloadPromise) {
    preloadPromise = (async () => {
      await getAudioContext();
      await Promise.all(
        (Object.entries(DRUM_URLS) as [DrumId, string][]).map(([drum, url]) =>
          loadTrimmedSample(drumKey(drum), url, DRUM_TRIM_THRESHOLD),
        ),
      );
    })();
  }
  return preloadPromise;
}

export function playDrumSample(drum: DrumId, volume = getDrumsChannelGain()): void {
  void playSampleNow(drumKey(drum), volume);
}

export function previewDrumSample(drum: DrumId): void {
  void playSampleNow(drumKey(drum), getDrumsChannelGain());
}
